// extracted by mini-css-extract-plugin
var _1 = "src-components-common-frames-Segments-module__segment_after";
var _2 = "src-components-common-frames-Segments-module__segment_before";
var _3 = "src-components-common-frames-Segments-module__segment_complex";
var _4 = "src-components-common-frames-Segments-module__segment_empty";
var _5 = "src-components-common-frames-Segments-module__segment_gap";
var _6 = "src-components-common-frames-Segments-module__segment_simple";
var _7 = "src-components-common-frames-Segments-module__segments";
var _8 = "src-components-common-frames-Segments-module__segments_horizontal";
var _9 = "src-components-common-frames-Segments-module__segments_vertical";
export { _1 as "segment_after", _2 as "segment_before", _3 as "segment_complex", _4 as "segment_empty", _5 as "segment_gap", _6 as "segment_simple", _7 as "segments", _8 as "segments_horizontal", _9 as "segments_vertical" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"segment_after\":\"src-components-common-frames-Segments-module__segment_after\",\"segment_before\":\"src-components-common-frames-Segments-module__segment_before\",\"segment_complex\":\"src-components-common-frames-Segments-module__segment_complex\",\"segment_empty\":\"src-components-common-frames-Segments-module__segment_empty\",\"segment_gap\":\"src-components-common-frames-Segments-module__segment_gap\",\"segment_simple\":\"src-components-common-frames-Segments-module__segment_simple\",\"segments\":\"src-components-common-frames-Segments-module__segments\",\"segments_horizontal\":\"src-components-common-frames-Segments-module__segments_horizontal\",\"segments_vertical\":\"src-components-common-frames-Segments-module__segments_vertical\"}";
        // 1777708299955
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  